import { createSlice } from "@reduxjs/toolkit";
import { fetchShipDetails } from "../../thunks/widgety/fetchShipDetails";

const fetchShipDetailsSlice = createSlice({
  name: "ship",
  initialState: {
    shipData: null, // Changed from [] to null
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShipDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShipDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.shipData = action.payload;
      })
      .addCase(fetchShipDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default fetchShipDetailsSlice.reducer;
